import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { Box, DashboardModule, Text } from '@domain-group/suit-theme'

import useChartData from '@hooks/useChartData'

import { taskTypeSettings } from '@functions/taskListItem'

interface TaskTypeCountsProps {
  requestOptions: {
    sub_tasks?: boolean,
    team_id: number | string,
  },
}

const TaskTypeCounts = (props: TaskTypeCountsProps) => {
  const { requestOptions } = props

  const chartDataPayload = useChartData('task_counts_by_type', { requestOptions })
  const { dataArray, loading } = chartDataPayload || {}

  if (!dataArray?.length){
    return null
  }

  return (
    <DashboardModule loading={loading} title="Task Counts">
      <Box flexDirection="column">
        {/*
         // @ts-expect-error TS7006 */}
        {dataArray.map((data) => {
          const { task_type, task_count } = data

          // @ts-expect-error TS7053
          const taskTypeSetting = taskTypeSettings[task_type] || {}
          const { icon, label } = taskTypeSetting

          return (
            <Box flexDirection="column" padding="large" key={task_type}>
              <Box alignItems="center" justifyContent="space-between">
                <Box flexDirection="row">
                  <Text color="bodyFontLightColor" marginRight="medium" fontSize="small">
                    <FontAwesomeIcon icon={icon} />
                  </Text>
                  <Text color="bodyFontLightColor" fontSize="small">
                    {label}
                  </Text>
                </Box>

                <Text fontSize="xlarge" color="darkGrey">
                  {task_count}
                </Text>
              </Box>
            </Box>
          )
        })}
      </Box>
    </DashboardModule>
  )
}

export default TaskTypeCounts
